import React from "react";
import Card from "../../components/page/Card";
import TabList from "../../components/Tab/TabList";
import TabButton from "../../components/Tab/TabButton";
import TabContent from "../../components/Tab/TabContent";
import ButtonRounded from "../../components/buttons/ButtonRounded";
import DadosPessoais from "./Colaborador/DadosPessoais";
import DadosContratuais from "./Colaborador/DadosContratuais";
import DocumentosAdmissao from "./Colaborador/DocumentosAdmissao";
import { useParams } from "react-router-dom";
import useLocalidade from "../../hooks/common/useLocalidade";
import useDadosPessoais from "../../hooks/colaboradores/useDadosPessoais";
import useDadosContratuais from "../../hooks/colaboradores/useDadosContratuais";
import useDocumentosColaborador from "../../hooks/colaboradores/useDocumentosColaborador";
import TabPane from "../../components/Tab/TabPane";
import useDocumentos from "../../hooks/common/useDocumentos";
import CommonSwal from "../../components/Swal/commonSwal";
import JornadaModal from "./JornadaTrabalho/JornadaModal";
import useApi from "../../hooks/useApi";
import ColaboradoresApiClient from "../../api/colaboradores";
import { AppContext } from "../../contexts/AppContext";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import SolicitarAdmissaoModal from "./Colaborador/SolicitarAdmissaoModal";
import { adicionarDiasUteis } from "../../helpers/mesesHelper";

function Admissao() {
  const { session, baseUrl } = React.useContext(AppContext);
  const [values, setValues] = React.useState({});
  const [tabAtual, setTabAtual] = React.useState(0);
  const [solicitarAdmissaoModal, setSolicitarAdmissaoModal] =
    React.useState(false);
  const [estadosNascimento, setEstadosNascimento] = React.useState({});
  const [estadoNascimento, setEstadoNascimento] = React.useState("");
  const { uid } = useParams();

  const solicitarAdmissaoApi = useApi(ColaboradoresApiClient.solicitarAdmissao);

  const {
    dependentes,
    dadosPessoaisValues,
    setDadosPessoaisValues,
    municipioAtivo,
    salvaDadosPessoais,
    novoDependente,
    excluirDependente,
    dadosPessoaisOriginalValues,
    setDadosPessoaisOriginalValues,
  } = useDadosPessoais(uid);
  const { estados, municipios, getMunicipios, getCep, cepResponse } =
    useLocalidade(estadoNascimento);
  const {
    jornadas,
    jornada,
    togNovaJornadaModal,
    salvaDadosContratuais,
    dadosContratuaisValues,
    setDadosContratuaisValues,
    jornadaValues,
    jornadaModal,
    setJornadaModal,
    salvaJornada,
    setJornadaValues,
    dadosContratuaisOriginalValues,
    setDadosContratuaisOriginalValues,
  } = useDadosContratuais(uid, { values, setValues });
  const {
    documentosAdmissao,
    setDocumentosAdmissao,
    excluirDocumento,
    uploadDocumento,
  } = useDocumentosColaborador(uid);
  const { downloadDocumento } = useDocumentos();

  // Busca municipios ao alterar valor do campo estado
  React.useEffect(() => {
    if (!estadoNascimento) return;
    getMunicipios();
  }, [getMunicipios, estadoNascimento]);

  // Define uid do estado selecionado
  React.useEffect(() => {
    if (!dadosPessoaisValues?.uf_nascimento || Object.keys(estados) < 1) return;
    const selectUF = document.getElementById("uf_nascimento");
    const selectedOption = selectUF.selectedOptions[0];
    const ufId = selectedOption ? selectedOption.dataset.ufid : null;
    setEstadoNascimento(ufId);
  }, [estados, dadosPessoaisValues?.uf_nascimento, setDadosPessoaisValues]);

  // Define cidade de nascimento caso nenhuma esteja selecionada
  React.useEffect(() => {
    if (
      !municipioAtivo ||
      Object.keys(municipios) < 1 ||
      dadosPessoaisValues?.cidade_nascimento
    )
      return;
    setDadosPessoaisValues((prevValues) => ({
      ...prevValues,
      cidade_nascimento: municipioAtivo,
    }));
  }, [
    dadosPessoaisValues?.cidade_nascimento,
    municipioAtivo,
    municipios,
    setDadosPessoaisValues,
  ]);

  const salvaColaborador = async () => {
    await salvaDadosPessoais(true);
    await salvaDadosContratuais(true);
    CommonSwal({ text: "Dados salvos com sucesso!", icon: "success" });
    setDadosPessoaisOriginalValues(dadosPessoaisValues);
    setDadosContratuaisOriginalValues(dadosContratuaisValues);
  };

  React.useEffect(() => {
    if (Object.keys(estados).length === 0) return;

    setEstadosNascimento({
      ...estados,
      EX: {
        id: "EX",
        sigla: "EX",
      },
    });
  }, [estados]);

  const togSolicitarAdmissaoModal = async () => {
    await salvaDadosPessoais();
    await salvaDadosContratuais();
    setDadosPessoaisOriginalValues(dadosPessoaisValues);
    setDadosContratuaisOriginalValues(dadosContratuaisValues);
    const formData = new FormData();
    formData.append("cnh_rg", documentosAdmissao?.cnh_rg);
    formData.append("titulo_ir", documentosAdmissao?.titulo_ir);
    parseInt(dadosContratuaisValues?.categoria) === 1 &&
      formData.append(
        "exame_admissional",
        documentosAdmissao?.exame_admissional
      );
    parseInt(dadosContratuaisValues?.categoria) === 2 &&
      formData.append(
        "contrato_faculdade",
        documentosAdmissao?.contrato_faculdade
      );

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    setSolicitarAdmissaoModal(true);
  };

  const solicitaAdmissao = async () => {
    const formData = new FormData();
    formData.append("nome_colaborador", dadosPessoaisValues?.nome);
    formData.append("cpf_colaborador", dadosPessoaisValues?.cpf);
    formData.append("data_admissao", values?.data_admissao);
    formData.append("uid_colaborador", uid);

    const dataMinima = adicionarDiasUteis(4).toISOString().split("T")[0];

    if (Validation.validarDataMinMax(values?.data_admissao, dataMinima))
      return ErrorSwal({
        text: "Favor preencher com uma data válida.",
      });

    const response = await solicitarAdmissaoApi.request(
      session.empresa.replace(/E/gi, ""),
      uid,
      formData,
      session?.user_guid
    );
    if (!response) return;
    CommonSwal({
      icon: "success",
      title: "Solicitação enviada com sucesso!",
      text: 'Acompanhe sua solicitação na aba "Admissões" do menu "Colaboradores".',
    }).then((result) => {
      if (result.isConfirmed || result.isDismissed)
        window.location.href = `${baseUrl}colaboradores/Colaboradores`;
    });
  };

  const retornar = async () => {
    const comparaDiferencas = (valores, valoresOriginais) => {
      const camposIgnorados = [
        "nome_dependente",
        "cpf_dependente",
        "data_nascimento_dependente",
        "tipo_dependente",
        "estadoNascimento",
      ];

      const chaves = Object.keys({
        ...valores,
        ...valoresOriginais,
      }).filter((key) => !camposIgnorados.includes(key));

      const chavesDiferentes = chaves.filter(
        (key) => String(valores[key]) !== String(valoresOriginais[key])
      );

      chavesDiferentes.forEach((key) => {
        console.warn(
          `Chave diferente: ${key}, Valor atual: ${valores[key]}, Valor original: ${valoresOriginais[key]}`
        );
      });

      return chavesDiferentes.length > 0;
    };

    const possuiDiferencasP = comparaDiferencas(
      dadosPessoaisValues,
      dadosPessoaisOriginalValues
    );

    const possuiDiferencasC = comparaDiferencas(
      dadosContratuaisValues,
      dadosContratuaisOriginalValues
    );

    if (possuiDiferencasP || possuiDiferencasC)
      return OptionsSwal({
        icon: "warning",
        title: "Deseja salvar as alterações realizadas?",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await salvaDadosPessoais(true);
          await salvaDadosContratuais(true);
          window.location.href = `${baseUrl}colaboradores/Colaboradores`;
        }
        if (result.isDenied) {
          window.location.href = `${baseUrl}colaboradores/Colaboradores`;
        }
      });
    else window.location.href = `${baseUrl}colaboradores/Colaboradores`;
  };

  return (
    <>
      <Card>
        <div className="row my-3">
          <div style={{ justifyContent: "end", display: "flex" }}>
            <ButtonRounded
              color="orange"
              onClick={() => {
                window.open(process.env.REACT_APP_NOVO_TICKET_URL, "_blank");
              }}
            >
              <i className="bx bx-support me-1"></i>Solicitar alteração
            </ButtonRounded>
          </div>
        </div>
        <TabList>
          <TabButton
            href="pessoaisTab"
            ativo={true}
            onClick={() => {
              setTabAtual(0);
            }}
          >
            Dados pessoais
          </TabButton>
          <TabButton
            href="contratuaisTab"
            onClick={() => {
              setTabAtual(1);
            }}
          >
            Dados contratuais
          </TabButton>
          <TabButton
            href="documentosTab"
            onClick={() => {
              setTabAtual(2);
            }}
          >
            Documentos do colaborador
          </TabButton>
        </TabList>
        <TabContent>
          <TabPane id="pessoaisTab" ativo={true}>
            <DadosPessoais
              valuesHook={{
                values: dadosPessoaisValues,
                setValues: setDadosPessoaisValues,
              }}
              estados={estadosNascimento}
              municipios={municipios}
              cepApi={{ getCep, cepResponse }}
              dependentes={dependentes}
              tabHook={{ tabAtual, setTabAtual }}
              salvaColaborador={salvaColaborador}
              admissao={true}
              editavel={
                dadosPessoaisValues?.visualizar === "0" ||
                dadosPessoaisValues?.visualizar === false
              }
              novoDependente={novoDependente}
              excluirDependente={excluirDependente}
              retornar={retornar}
            />
          </TabPane>
          <TabPane id="contratuaisTab">
            <DadosContratuais
              valuesHook={{
                values: dadosContratuaisValues,
                setValues: setDadosContratuaisValues,
              }}
              jornadas={jornadas}
              jornada={jornada}
              togNovaJornadaModal={togNovaJornadaModal}
              tabHook={{ tabAtual, setTabAtual }}
              salvaColaborador={salvaColaborador}
              admissao={true}
              editavel={
                dadosPessoaisValues?.visualizar === "0" ||
                dadosPessoaisValues?.visualizar === false
              }
              salarioEditavel={
                dadosPessoaisValues?.visualizar === "0" ||
                dadosPessoaisValues?.visualizar === false
              }
              retornar={retornar}
            />
          </TabPane>
          <TabPane id="documentosTab">
            <DocumentosAdmissao
              valuesHook={{
                values: documentosAdmissao,
                setValues: setDocumentosAdmissao,
              }}
              downloadDocumento={downloadDocumento}
              excluirDocumento={excluirDocumento}
              dadosContratuaisValues={dadosContratuaisValues}
              editavel={
                dadosPessoaisValues?.visualizar === "0" ||
                dadosPessoaisValues?.visualizar === false
              }
              uploadDocumento={uploadDocumento}
              tabHook={{ tabAtual, setTabAtual }}
              salvaColaborador={salvaColaborador}
              togSolicitarAdmissaoModal={togSolicitarAdmissaoModal}
              retornar={retornar}
            />
          </TabPane>
        </TabContent>
      </Card>
      <JornadaModal
        valuesHook={{ values: jornadaValues, setValues: setJornadaValues }}
        isOpen={jornadaModal}
        setIsOpen={setJornadaModal}
        novo={true}
        salvaJornada={salvaJornada}
      />
      <SolicitarAdmissaoModal
        valuesHook={{ values, setValues }}
        isOpen={solicitarAdmissaoModal}
        setIsOpen={setSolicitarAdmissaoModal}
        solicitaAdmissao={solicitaAdmissao}
      />
    </>
  );
}

export default Admissao;
